import { TaskInstance } from '../task/task-instance';

/**
 * REST API model
 */
export class ProcessInstanceTasksEntry {
  entry: TaskInstance;

  constructor(input?: any) {
    if (input) {
      Object.assign(this, input);
      this.entry = input.entry ? new TaskInstance(input.entry) : undefined;
    }
  }
}
